import './MobileRadio.scss';

import { isString, startCase } from 'lodash';
import React from 'react';

import { ReactComponent as CheckCircle } from 'assets/icons/check-circle.svg';

const MobileRadio = ({
  option,
  className = '',
  selected,
  onChange,
  toggle = ''
}) => {
  const { value, label } = isString(option)
    ? { value: option, label: startCase(option) }
    : option;
  const classNames = `${className} e2e-${value}`;

  return (
    <div
      className={classNames}
      onClick={
        toggle ? onChange.bind(this, value, toggle) : onChange.bind(this, value)
      }>
      <div className="mobile-radio-label">{label}</div>
      {selected === value ? (
        <CheckCircle className="mobile-active-radio" />
      ) : (
        <div className="mobile-inactive-radio" />
      )}
    </div>
  );
};

export default MobileRadio;
